import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbadd77c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "name c-primary" }
const _hoisted_2 = { class: "author c-thirdary" }

import Poster from '@/views/components/Poster.vue';
import * as links from '@/views/links';

interface Props {
    album: MovieAlbum,
}

export default /*#__PURE__*/_defineComponent({
  props: {
    album: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "album link line",
    to: _unref(links).album(__props.album.movid)
  }, {
    default: _withCtx(() => [
      _createVNode(Poster, {
        url: __props.album.thumb,
        theme: "album"
      }, null, 8, ["url"]),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(__props.album.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.album.speaker), 1)
    ]),
    _: 3
  }, 8, ["to"]))
}
}

})